module.exports = __webpack_public_path__ + "static/img/plate_title_3.bae8719.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/module/dataIndex/static/plate_title_3.png
// module id = 7f8x
// module chunks = 60